import Vue from 'vue'
import VueRouter from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

import NotFound from '@/pages/404.vue'
import Home from '@/pages/Home.vue'
import history_alarm_charts from '@/pages/history_alarm/history_alarm_charts.vue'
import current_alarm_list from '@/pages/current_alarm/current_alarm_list.vue'
import bussiessGroup_list from '@/pages/system_setup/group_list.vue'
import userManagelist from '@/pages/system_setup/user_list.vue'
import projectlist from '@/pages/system_setup/project_list.vue'
import history_alarm_list from '@/pages/history_alarm/history_alarm_list.vue'
import alarm_push_manage from '@/pages/system_setup/alarm_push_manage.vue'
import account_login from '@/pages/account/login.vue'


NProgress.configure({ showSpinner: false });
Vue.use(VueRouter)

let routes = [
    {
        path: '/login',
        component: account_login,
        name: '',
        hidden: true
    },
    {
        path: '/404',
        component: NotFound,
        name: '',
        hidden: true
    },
    {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'el-icon-warning',
        leaf: true,
        children: [
            { path: '/currentAlarm', component: current_alarm_list, name: '当前告警' }
        ]
    },
    
    // {
    //     path: '*',
    //     hidden: true,
    //     redirect: { path: '/404' }
    // }
];
const router = new VueRouter({
    routes: routes
})

router.beforeEach((to, from, next) => {
    NProgress.start();
    let user = JSON.parse(sessionStorage.getItem('user'));
    let acceptPrivacyAgreementRequired = JSON.parse(sessionStorage.getItem('acceptPrivacyAgreementRequired'));
    let verifyEmailRequired = JSON.parse(sessionStorage.getItem('verifyEmailRequired'));
    if (to.path == '/login') {
      if(user && !acceptPrivacyAgreementRequired && !verifyEmailRequired) next({ path: '/currentAlarm' })
      else next()
    }
    if (!user && to.path != '/login' || (acceptPrivacyAgreementRequired || verifyEmailRequired)) {
        next({ path: '/login' })
    }
    else {
        next()
    }
  })
  
router.afterEach(transition => {
    NProgress.done();
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js